import DynamicBanner, { DynamicBannerProps } from "./DynamicBanner";

export { DynamicBanner, DynamicBannerProps };

export default DynamicBanner;
